/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react"
import Modal from "react-modal"
import Select from "react-select"
import MaskedInput from "react-maskedinput"
import { CircularProgress } from "@material-ui/core"
import { getRequest, putRequest, postRequest } from "utils/request"

import { i18n } from "../../translate/i18n"

import { useModal } from "hooks/modal"

import "./style.css"
import { useAuth } from "hooks/auth"
import { tzList } from "utils/timezoneList"

const I18N_STORAGE_KEY = "i18nextLng"

export default function Profile({ match, history }) {
  const [loading, setLoading] = useState(false)
  const [userTypes, setUserTypes] = useState([])
  const [listCompanies, setListCompanies] = useState([])
  const [name, setName] = useState("")
  const [nickName, setNickName] = useState("")
  const [email, setEmail] = useState("")
  const [login, setLogin] = useState("")
  const [document, setDocument] = useState("")
  const [UserTypeID, setUserTypeID] = useState("")
  const [language, setLanguage] = useState("")
  const [timeZone, setTimeZone] = useState("")
  const [languageDb, setLanguageDb] = useState("")
  const [userCompanies, setUserCompanies] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [photo, setPhoto] = useState("")
  const [previewphoto, setPreviewPhoto] = useState("")
  const [companiesModal, setCompaniesModal] = useState(false)
  const [enterKeySendsMessage, setEnterKeySendsMessage] = useState(false)

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "40%",
      minHeight: "30%",
      height: "60%",
      minWidth: "580px",
      position: "relative",
    },
    overlay: {
      overflow: "auto",
      transition: "(top 0.4s, opacity 0.4s)",
      zIndex: 1003,
      background: "rgba(0, 0, 0, 0.4)",
    },
  }

  const { toggleHelperId } = useModal()

  const { user, updateUser } = useAuth()

  const loadUser = async () => {
    setLoading(true)

    //const UserId = JSON.parse(localStorage.getItem("user-omni")).id;

    //BUSCA PERFIS DISPONIVEIS
    const ReturnGet = await getRequest(`/userstypes`)
    if (ReturnGet.success) {
      setUserTypes(ReturnGet.data)
    }

    //BUSCA EMPRESAS DISPONIVEIS
    let ReturnGet2 = await getRequest(`/userscompanies/partners?includeOmni=0`)
    if (ReturnGet2.success) {
      let opt = []
      ReturnGet2.data.forEach((company) => {
        opt.push({
          value: company.id,
          label: company.nickName,
          CompanyId: company.id,
          CompanyDepartments: company.CompanyDepartments.map((deparment) => ({
            ...deparment,
            value: deparment.id,
            label: deparment.description,
          })),
        })
      })
      setListCompanies(opt)
    }

    //BUSCA DADOS DO USUÁRIO
    const ReturnGet3 = await getRequest(`/users/${user.id}`)
    if (ReturnGet3.success) {
      setPhoto(ReturnGet3.data.photo)
      setPreviewPhoto(ReturnGet3.data.photo)
      setName(ReturnGet3.data.name)
      setNickName(ReturnGet3.data.nickName)
      setLogin(ReturnGet3.data.login)
      setEmail(ReturnGet3.data.email)
      setDocument(ReturnGet3.data.document)
      setUserTypeID(ReturnGet3.data.UserTypeId)
      setLanguage(ReturnGet3.data.language)
      setLanguageDb(ReturnGet3.data.language)
      setTimeZone(ReturnGet3.data.timeZone)
      setEnterKeySendsMessage(ReturnGet3.data.enterKeySendsMessage)

      let companies = ReturnGet3.data.UserCompanies
      let companiesID = []

      companies.map((userCompany) => {
        companiesID.push({
          value: userCompany?.CompanyId,
          label: userCompany?.Company?.nickName,
          CompanyId: userCompany?.Company?.id,
          CompanyDepartments: userCompany?.CompanyDepartments.map(
            (deparment) => ({
              ...deparment,
              value: deparment.id,
              label: deparment.description,
            })
          ),
        })
      })
      setUserCompanies(companiesID)
      setLoading(false)
    }
  }

  const handleConfirm = async () => {
    setLoading(true)

    //const UserId = JSON.parse(localStorage.getItem("user-omni")).id;

    //SALVA ALTERAÇÕES DO USUÁRIO
    const newUser = {
      name,
      nickName,
      email,
      document,
      language,
      timeZone,
      enterKeySendsMessage,
    }

    const ReturnPut = await putRequest(`/users/staff/${user.id}`, newUser)
    if (ReturnPut.success) {
      updateUser({ ...user, ...newUser })
    }
    if (language !== languageDb) {
      // toast.success(i18n.t('languageChange'));
      setTimeout(1000)
      localStorage.setItem(I18N_STORAGE_KEY, language)
      window.location.reload()
    }

    setLoading(false)
  }

  const handleUploadAvatar = async (file) => {
    setLoading(true)

    const formData = new FormData()
    formData.append("avatar", file.target.files[0])

    //ENVIA MENSAGEM
    const ReturnPost = await postRequest(`/users/avatar`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })

    if (ReturnPost.success) {
      setPreviewPhoto(URL.createObjectURL(file.target.files[0]))
      updateUser({ ...user, photo: ReturnPost.data.photo })
    }

    setLoading(false)
  }

  const ConfigMask = (data) => {
    let value
    value = data.replace(/([^\d])+/gim, "")
    return value
  }

  //ABRE O MODAL DE EMPRESAS E DEPARTAMENTOS DO USUÁRIO
  const toggleModalCompanies = async () => {
    setCompaniesModal(true)
  }

  const getUserCompanyDepartments = (companyId) => {
    const userCompany = userCompanies.find((uc) => uc.CompanyId === companyId)
    if (!userCompany) return []

    return userCompany.CompanyDepartments
  }

  useEffect(() => {
    loadUser()
    toggleHelperId(1)
  }, [])

  return (
    <>
      <Modal
        isOpen={companiesModal}
        style={customStyles}
        onRequestClose={() => setCompaniesModal(false)}
        ariaHideApp={false}
      >
        <span
          onClick={() => setCompaniesModal(false)}
          style={{
            fontSize: 30,
            position: "absolute",
            right: 15,
            top: 0,
            color: "black",
            cursor: "pointer",
          }}
        >
          <i className="fas fa-times"></i>
        </span>
        <div className="form-row col-md-12">
          <h4 className="header-title">{i18n.t("company")}</h4>
          <div className="form-group col-md-12">
            <Select
              placeholder=""
              options={listCompanies}
              isMulti
              isDisabled
              getStyles="select2 form-control select2-multiple"
              value={userCompanies}
            />
          </div>
        </div>

        <div className="form-row col-md-12">
          <h4 className="header-title">{i18n.t("departments")}</h4>
          {listCompanies.map((company) => (
            <div
              className="form-group col-md-12"
              key={company.id}
              style={{
                display: userCompanies.find(
                  (uc) => uc.CompanyId === company.CompanyId
                )
                  ? "block"
                  : "none",
              }}
            >
              <label>{company.label}</label>
              <Select
                options={company.CompanyDepartments}
                isMulti
                isDisabled
                getStyles="select2 form-control select2-multiple"
                value={getUserCompanyDepartments(company.CompanyId)}
              />
            </div>
          ))}
        </div>
      </Modal>
      <div className="col-12" style={{ overflowY: "auto" }}>
        <div className="container-card">
          {!loading ? (
            <>
              <form
                className="form-edit"
                onSubmit={(e) => {
                  e.preventDefault()
                  handleConfirm()
                }}
              >
                <h4 className="header-title">{i18n.t("profileHeader")}</h4>
                <div className="container-page-profile">
                  <div className="form-row">
                    <div
                      className="form-group col-md-2"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div className="area-avatar-perfil-config">
                        <img
                          key={previewphoto}
                          src={previewphoto}
                          className="img-avatar-perfil-config"
                          alt="avatar"
                        />
                        <div className="image-upload">
                          <label htmlFor="file-input">
                            <div className="icon-avatar-camera-perfil-config">
                              <i className="mdi mdi  mdi mdi-camera" />
                            </div>
                          </label>
                          <input
                            id="file-input"
                            type="file"
                            onChange={handleUploadAvatar}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group col-md-7">
                      <div className="form-row">
                        <div className="form-group col-md-12">
                          <label>{i18n.t("login")}</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Login"
                            disabled
                            value={login}
                            onChange={(value) => setLogin(value.target.value)}
                          />
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group col-md-6">
                          <label> {i18n.t("name")}</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Nome"
                            maxLength={100}
                            required
                            value={name}
                            onChange={(value) => setName(value.target.value)}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label> {i18n.t("nickname")}</label>
                          <input
                            type="text"
                            maxLength={100}
                            className="form-control"
                            placeholder="Nome"
                            required
                            value={nickName}
                            onChange={(value) =>
                              setNickName(value.target.value)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group col-md-3">
                      <label>{i18n.t("document")}</label>
                      <MaskedInput
                        mask="111.111.111-11"
                        type="text"
                        className="form-control"
                        data-toggle="input-mask"
                        data-mask-format="000.000.000-00"
                        data-reverse="true"
                        maxLength="14"
                        minLength="14"
                        placeholder="000.000.000-00"
                        required
                        value={document}
                        onChange={(value) =>
                          setDocument(ConfigMask(value.target.value))
                        }
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label> {i18n.t("email")}</label>
                      <input
                        type="email"
                        id="example-email"
                        maxLength={100}
                        name="example-email"
                        className="form-control"
                        value={email}
                        placeholder="exemplo@exemplo.com.br"
                        onChange={(value) => setEmail(value.target.value)}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-3">
                      <label>{i18n.t("profile")}</label>
                      <select
                        className="form-control select2"
                        data-toggle="select2"
                        disabled
                        value={UserTypeID}
                      >
                        <option value="">Selecione</option>
                        {userTypes.map((data, index) => (
                          <option key={index} value={data.id}>
                            {data.description}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group col-md-3">
                      <label>Chat</label>

                      <div className="checkbox-container">
                        <input
                          name="enterKeySendsMessage"
                          checked={enterKeySendsMessage}
                          onChange={() => {
                            setEnterKeySendsMessage(!enterKeySendsMessage)
                          }}
                          type="checkbox"
                          className="checkbox"
                          // style={{ marginBottom: "12px" }}
                        />
                        <div style={{ marginLeft: 15 }}>
                          {i18n.t("enterKeySendsMessage")}
                        </div>
                      </div>
                    </div>
                    <div className="form-row" style={{ marginTop: 15 }}>
                      <div className="form-group col-md-3">
                        <label>{i18n.t("language")} *</label>
                        <select
                          value={language}
                          className="form-control select2-multiple"
                          onChange={(e) => setLanguage(e.target.value)}
                          required
                        >
                          <option value="">{i18n.t("empty")}</option>
                          <option value="pt-BR">{i18n.t("portuguese")}</option>
                          <option value="es">{i18n.t("spanish")}</option>
                        </select>
                      </div>
                      <div className="form-group col-md-3">
                        <label> {i18n.t("timeZone")} *</label>
                        <select
                          className="form-control select2"
                          data-toggle="select2"
                          value={timeZone}
                          name="timeZone"
                          required
                          onChange={(e) => setTimeZone(e.target.value)}
                        >
                          <option value="">{i18n.t("select")}</option>
                          {tzList.map((data, index) => (
                            <option key={index} value={data.value}>
                              {data.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div
                    className="button-list mt-3 pull-right"
                    style={{
                      position: "absolute",
                      bottom: 0,
                      right: 0,
                      marginRight: 30,
                      marginBottom: 5,
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={() => toggleModalCompanies()}
                    >
                      <i className="mdi mdi-domain"></i>
                      {i18n.t("company")}
                    </button>
                    <button type="submit" className="btn btn-outline-success">
                      <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                      {i18n.t("save")}
                    </button>
                  </div>
                </div>
              </form>
            </>
          ) : (
            <div className="area-loading">
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
    </>
  )
}
